import { useEffect, useRef, useState } from 'react';
import api from 'util/api';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import {
  useNotificationsStore,
  LoadingIndicator,
  Tooltip
} from '@thermon-platforms/thermon-ui-core';
import { printAsPDF } from 'util/misc';
import { formatNote } from './util';


function Notes({ device }) {
  const notesInput = useRef();
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addingNote, setAddingNote] = useState(false);
  const [, notificationsStoreActions] = useNotificationsStore();

  async function fetchNotes() {
    setLoading(true);
    try {
      const res = await api(`/devices/${device.id}/notes`);
      const data = await res.json();
      setNotes(data);
    } catch (error) {
      notificationsStoreActions.notify(
        'Error fetching notes',
        'alert'
      );
    } finally {
      setLoading(false);
    }
  }

   async function addNote() {
    if (!notesInput.current.value) return;
    setAddingNote(true);
    const res = await api(`/devices/notes`, {
      method: 'POST',
      body: JSON.stringify({
        noteText: notesInput.current.value,
        deviceId: device.id,
      })
    })
      .finally(() => setAddingNote(false));

    const note = await res.json();
    setNotes([...notes, note]);
    notesInput.current.value = '';
  }

  function deleteNote(noteId) {
    api(`/devices/notes/${noteId}`, {
      method: 'DELETE'
    })
      .then(() => {
        setNotes(notes.filter(n => n.noteId != noteId));
      })
      .catch(() => {/* no-op */});
  }

  useEffect(() => {
    fetchNotes();
  }, [device]);

  return (
    <div className="notes">
      <header>
        <label htmlFor={`device-${device.id}-notes`}><Trans>Notes</Trans></label>:
        <button
          className="print small"
          onClick={() => printAsPDF([device.name, ...notes.map(formatNote)].join('\n\n\n'))}
          data-tooltip-content={t`Print Notes`}
          data-tooltip-id={`notes-control-tooltip`}
        >
          <Trans>Print Notes</Trans>
        </button>
      </header>
      {!loading ? notes?.map((note, i) =>
        <div className="note" key={`note-${i}`}>
          {note.noteText}
          <br />
          <em>&ndash; {note.createdBy} {new Date(note.createdAt).toLocaleString()}</em>
          <button
            className="small delete"
            onClick={() => deleteNote(note.noteId)}
            data-tooltip-content={t`Delete Note`}
            data-tooltip-id={`notes-control-tooltip`}
          >
            <Trans>Delete</Trans>
          </button>
        </div>
      ) : <LoadingIndicator />}
      <textarea
        placeholder="Add note..."
        ref={notesInput}
        id={`device-${device.id}-notes`}
        name={`device-${device.id}-notes`}
        disabled={addingNote}
      />
      <button
        className={`small ${addingNote ? 'processing' : ''}`}
        onClick={addNote}
        disabled={addingNote}
      >
        <Trans>Add</Trans>
      </button>
      <Tooltip id="notes-control-tooltip" />
    </div>
  );
}

export default Notes;
